import Image from "next/image";
import React, { useState } from "react";

const UspROIDesktop: React.FC = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      <div className="w-full md:pt-[50px] pt-[32px] md:pb-[50px] pb-[32px] bg-[#0C1F33] relative z-[9]">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 md:block hidden">
          <div className="text-center">
            <h2 className="text-2xl lg:text-[36px] md:text-[38px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white text-center inline-block mx-auto px-[4px]">
              <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                Let’s talk ROI
              </span>
            </h2>
          </div>
          <div className="flex justify-center w-full">
            <div className="relative z-10 w-full gap-6 flex flex-row justify-center">
              <div className="bg-[#fff] w-[33%] border-[#F0F0F2] border-[6px] rounded-[10px] mt-4 px-4 py-3 z-10 relative">
                <div className="flex justify-center items-center gap-2">
                  <Image
                    src="/cpa/generic/inves.png"
                    alt="Special Offer"
                    width={41}
                    height={44}
                    priority
                  />
                  <span className="text-[22px] font-semibold">Investment</span>
                </div>

                <div className="rounded-[8px] text-center py-2 border-[#EDEDF0] border-[1px] bg-[#F8F8F8] font-semibold text-[16px] text-[#000f34b3] mt-2 leading-4">
                  Out of Pocket $2K <sup>^</sup>
                  <br /> + 
                  <br /> Student Loan
                </div>
              </div>

              <div className="bg-[#fff] w-[33%] border-[#F0F0F2] border-[6px] rounded-[10px] mt-4 px-4 py-3 z-10 relative">
                <div className="flex justify-center items-center gap-2 h-[42px]">
                  <Image
                    src="/cpa/generic/return.png"
                    alt="Special Offer"
                    width={41}
                    height={44}
                    priority
                  />
                  <span className="text-[22px] font-semibold">Returns</span>
                </div>

                <div className="rounded-[8px] text-center py-2 border-[#EDEDF0] border-[1px] bg-[#F8F8F8] font-semibold text-[16px] text-[#000f34b3] mt-2">
                  Salary: <br /> <span className="font-bold">$60K+</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-medium text-[16px] text-[white] tracking-[-0.6px] leading-[38px] ml-[16%] mt-[-2px]">
            ^Estimated
          </p>

          <div className="text-center pt-[30px]">
            <h2 className="text-2xl lg:text-[36px] md:text-[38px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white text-center inline-block mx-auto px-[4px]">
              Estimat
              <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                ed annual
              </span>{" "}
              savings
            </h2>
          </div>

          <div className=" md:w-[889px] mx-auto rounded-[16px] md:mt-6 mt-[10px]">
            <div className="overflow-x-auto rounded-[16px] border-[#3174d6]  border-[1px]">
              <table className="w-full">
                <thead></thead>
                <tbody className="bg-white">
                  <tr className="">
                    <td className="border-[1px] border-[#C0DDFD]">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#080C1E]">
                        Annual Salary
                      </span>
                    </td>
                    <td className="border-[1px] border-[#C0DDFD] text-center">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#080C1E]">
                        $60,000+
                      </span>
                    </td>
                  </tr>

                  <tr className="">
                    <td className="border-[1px] border-[#C0DDFD]">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#080C1E]">
                        Student Loan EMI (Principle + Interest)
                      </span>
                    </td>
                    <td className="border-[1px] border-[#C0DDFD] text-center">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#D05757]">
                        - $20,000
                      </span>
                    </td>
                  </tr>

                  <tr className="">
                    <td className="border-[1px] border-[#C0DDFD]">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#080C1E]">
                        Taxes
                      </span>
                    </td>
                    <td className="border-[1px] border-[#C0DDFD] text-center">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#D05757]">
                        - $5,000
                      </span>
                    </td>
                  </tr>

                  <tr className="">
                    <td className="border-[1px] border-[#C0DDFD]">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#080C1E]">
                        Living Expenses
                      </span>
                    </td>
                    <td className="border-[1px] border-[#C0DDFD] text-center">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-medium text-[#D05757]">
                        - $15,000
                      </span>
                    </td>
                  </tr>

                  <tr className="bg-[#C0DDFD]">
                    <td className="border-[1px] border-[#C0DDFD]">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[12px] block font-semibold text-[#3399FF]">
                        Savings per year
                      </span>
                    </td>
                    <td className="border-[1px] border-[#C0DDFD] text-center">
                      <span className="py-3 md:px-8 px-2 md:text-[20px] text-[11.5px] block font-semibold text-[#3399FF]">
                        $20,000+
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-[30px] mb-[10px] bg-[#ca7216] rounded-[8px]  md:w-[889px] mx-auto">
              <p className="text-[32px] leading-[38px] text-white text-center font-semibold py-[10px]">
                Save $60,000 in 3 years
              </p>
              <div className="w-full relative">
                <Image
                  src="/images/accounting/usp/arrow.png"
                  alt="Investment"
                  className="mx-auto w-[50px]  absolute -right-14 bottom-10 z-[8]"
                  width={71}
                  height={161}
                  priority
                />
              </div>
            </div>
          </div>
          <div className="text-center pt-16">
            <div className="flex justify-center">
              <div className="relative pb-10 w-[80%]">
                <div
                  className="video-gif relative rounded-[14px]"
                  onClick={() => {
                    openPopup("QqFAuZzvnDs");
                  }}
                >
                  <Image
                    src="https://ik.imagekit.io/mileseducation/miles_website/home/accountant_shortage.gif"
                    alt="Accountants"
                    className="cursor-pointer w-full rounded-[14px]"
                    width={500}
                    height={281}
                  />

                  <div className="flex items-center justify-center md:rounded-[15px] rounded-[15px] absolute left-0 right-0 bottom-[40%]">
                    <Image
                      src="/images/accounting/usp/video-icon.png"
                      alt="Accountants "
                      className="cursor-pointer w-[70px]"
                      width={110}
                      height={110}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Image
          src="/images/accounting/usp/solution-mount.png"
          alt="Special Offer"
          className="md:block hidden absolute left-0 bottom-0 mx-auto z-[-1] md:w-[650px]"
          width={920}
          height={630}
          priority
        />
        {isPopupOpen.open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000]">
            <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
              <button
                onClick={closePopup}
                className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
              >
                ✕
              </button>
              <iframe
                className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
                width="100%"
                id="huge-shortage-video-player"
                height="320"
                src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UspROIDesktop;
